import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { MessageOutput } from '../model/message.output';

export interface MarkMessagesReadParams {
	readonly messagesId: string[];
}

@Injectable({ providedIn: 'root' })
export class MarkMessagesReadApiMutation extends ApiMutation<
	MessageOutput[],
	MarkMessagesReadParams
> {
	client = 'messaging';
	document = gql`
		mutation MarkMessagesRead($messagesId: [UUID]!) {
			markMessagesRead(messagesId: $messagesId) {
				id
				content
				moduleId
				authorId
				documentId
				visioSessionId
				participantsId
				updateTimestamp
				creationTimestamp
			}
		}
	`;
	method = 'markMessagesRead';
}
